import { render, staticRenderFns } from "./WhatsAppIcon.vue?vue&type=template&id=1e377ade&scoped=true"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppIcon.vue?vue&type=style&index=0&id=1e377ade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e377ade",
  null
  
)

export default component.exports